import { useContractCall } from "@usedapp/core";

import { BigNumber, ethers } from "ethers";
import { ABI } from "../abi";

const useAllMintedSalesTokenIdList = (): BigNumber[] | undefined => {
  const idList: any = [];

  const call = {
    abi: new ethers.utils.Interface(ABI),
    address: process.env.REACT_APP_NFT_ADDRESS ?? "",
    method: "mintedSalesTokenIdList",
  };

  const [list1] = useContractCall({
    ...call,
    args: [0, 1000],
  }) ?? [undefined];
  const [list2] = useContractCall({
    ...call,
    args: [1000, 1000],
  }) ?? [undefined];
  const [list3] = useContractCall({
    ...call,
    args: [2000, 1000],
  }) ?? [undefined];
  const [list4] = useContractCall({
    ...call,
    args: [3000, 1000],
  }) ?? [undefined];
  const [list5] = useContractCall({
    ...call,
    args: [4000, 1000],
  }) ?? [undefined];
  const [list6] = useContractCall({
    ...call,
    args: [5000, 1000],
  }) ?? [undefined];
  const [list7] = useContractCall({
    ...call,
    args: [6000, 1000],
  }) ?? [undefined];
  const [list8] = useContractCall({
    ...call,
    args: [7000, 1000],
  }) ?? [undefined];
  const [list9] = useContractCall({
    ...call,
    args: [8000, 1000],
  }) ?? [undefined];
  const [list10] = useContractCall({
    ...call,
    args: [9000, 1000],
  }) ?? [undefined];

  [
    list1,
    list2,
    list3,
    list4,
    list5,
    list6,
    list7,
    list8,
    list9,
    list10,
  ].forEach((list) => idList.push(...(list ?? [])));

  return idList;
};

export default useAllMintedSalesTokenIdList;
